<template>
  <div class="text-center p-5">
    <p class="h3 mb-2">
      <strong>You have been invited to join {{ organization.organizationName }}</strong>
    </p>

    <b-card class="p-2">
      <b-avatar
        :src="orgImage"
        size="180"
      />
      <div class="mt-2">
        <h4><strong>{{ organization.organizationName }}</strong></h4>
      </div>
    </b-card>

    <div class="mb-2 h5">
      <strong>Ready To Join?</strong>
    </div>

    <b-button
      variant="outline-primary"
      class="mr-1 btn-pill"
      :href="$siteURL"
    >
      Reject
    </b-button>

    <b-button
      variant="primary"
      class="btn-pill"
      @click="acceptInvitation"
    >
      Accept
    </b-button>

  </div>
</template>

<script>
import Users from '@/compositions/TeamManagement/Users/UsersAPI'
import auth from '@/compositions/Auth/auth'

export default {
  name: 'AcceptInvitation',
  data() {
    return {
      organization: {},
    }
  },
  computed: {
    orgImage() {
      return this.organization.image
    },
  },
  setup() {
    const { loginOrganizer } = auth()
    const { getInvitationRequest, acceptInvitationRequest } = Users()
    return { loginOrganizer, getInvitationRequest, acceptInvitationRequest }
  },
  created() {
    this.getInvitation()
  },
  methods: {
    getInvitation() {
      this.getInvitationRequest(this.$route.query.token).then(res => {
        this.organization = res.data.data
      })
    },
    acceptInvitation() {
      this.acceptInvitationRequest(this.$route.query.token).then(() => {
        this.loginOrganizer().then(() => {
          this.redirectLoggedInUser()
        }).catch(() => {
          this.redirectGuestUser()
        })
      })
    },
    redirectLoggedInUser() {
      if (this.$auth) {
        if (this.$auth.has_multiple_organization) {
          this.$router.push({ name: 'organization-switch' })
        } else {
          this.$router.push({
            name: 'organization-profile',
            query: {
              firstTabIndex: 3,
              secondTabIndex: 1,
            },
          })
        }
      }
    },
    redirectGuestUser() {
      if (this.organization.userExists) {
        window.location.href = `${this.$siteURL}?showModal=true`
      } else {
        window.location.href = `${this.$siteURL}register?email=${this.organization.email}`
      }
    },
  },
}
</script>

<style>

</style>
